import React, { useEffect } from 'react';
import { SelectedSearchItem } from '@/search/search.types';
import { SelectItemSearchFormComponent } from '@/formbuilder/SelectItemSearchFormComponent';
import { TextFieldFormComponent } from '@/formbuilder/TextFieldFormComponent.atom';
import { ValidatingFormComponent } from '@/formbuilder/formBuilder.constants';
import { Checkbox } from '@seeqdev/qomponents';
import { useTranslation } from 'react-i18next';

export interface ToggleInputSelectItemSearchFormComponentProps
  extends ValidatingFormComponent<string | number | SelectedSearchItem[] | null> {
  component: 'ToggleInputSelectItemSearchFormComponent';
  showItemSelection?: boolean;
  setShowItemSelection: (columnId: string, showItemSelection: boolean) => void;
  label?: string;
  name: string;
  size: 'sm' | 'lg';
  value: string | number | SelectedSearchItem[] | null;
  required: boolean;
  testId?: string;
  onChange: (value: string | number | SelectedSearchItem[] | null) => void;
  isMultiple?: boolean;
  notSelectedMessage: string;
  title?: string;
  overrideWorkbookId?: string;
  searchTypes: string[];
  iconPartialTooltipKey: string;
  customCalcInstructions: string;
  unit?: string;
  showToggle?: boolean;
}

export const ToggleInputSelectItemSearchFormComponent: React.FunctionComponent<
  ToggleInputSelectItemSearchFormComponentProps
> = (props) => {
  const {
    showItemSelection = false,
    setShowItemSelection,
    showToggle = true,
    value,
    name,
    testId,
    size,
    required,
    onChange,
    searchTypes,
    notSelectedMessage,
    iconPartialTooltipKey,
    overrideWorkbookId,
    isMultiple,
    customCalcInstructions,
    unit,
  } = props;

  const { t } = useTranslation();

  return (
    <div className="flexRowContainer width-70percent pt15">
      <div className="flexRowContainer">
        <div className="pb8">{props.label}</div>

        {showToggle && (
          <div className="flexColumnContainer pb5">
            <Checkbox
              type="radio"
              value="valueInput"
              checked={!showItemSelection}
              onChange={() => setShowItemSelection(name, false)}
              id="valueInputCheckbox"
              label={t('IMPACT_REPORT.ENTER_AMOUNT')}
            />
            <Checkbox
              extraClassNames="ml10"
              type="radio"
              checked={showItemSelection}
              value="customSignalInput"
              onChange={() => setShowItemSelection(name, true)}
              id="valueInputCheckbox"
              label={t('IMPACT_REPORT.USE_CALCULATION')}
            />
          </div>
        )}
      </div>
      {showItemSelection ? (
        <div className="flexRowContainer">
          <div className="flexColumnContainer flexAlignCenter">
            <SelectItemSearchFormComponent
              component="SelectItemSearchFormComponent"
              title="IMPACT_REPORT.SELECT_CALCULATION"
              name={name}
              value={value as SelectedSearchItem[]}
              isMultiple={isMultiple}
              searchTypes={searchTypes}
              iconPartialTooltipKey={iconPartialTooltipKey}
              overrideWorkbookId={overrideWorkbookId}
              onChange={onChange}
              notSelectedMessage={notSelectedMessage}
            />{' '}
            {unit && unit !== '' && <div className="ml15">{unit}</div>}
          </div>
          <span className="font-size-smaller">{customCalcInstructions}</span>
        </div>
      ) : (
        <TextFieldFormComponent
          type="number"
          min={0}
          component="TextFieldFormComponent"
          label=""
          wrapperClassNames="width-maximum"
          name={name}
          testId={testId}
          value={value as number}
          onChange={onChange}
          required={required}
          size={size}
        />
      )}
    </div>
  );
};
